import { render } from "./Add.vue?vue&type=template&id=216b8fee&scoped=true"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import "./Add.vue?vue&type=style&index=0&id=216b8fee&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216b8fee"]])

export default __exports__